import { Card } from '@/utils/models/cards';

export const SanitizeColumnData = (data: Card['secondaryData'] | Card['primaryData']) => {
  if (Array.isArray(data)) {
    return (
      <>
        {data.map((data, key) => (
          <div dangerouslySetInnerHTML={{ __html: data }} key={key} />
        ))}
      </>
    );
  }

  if (typeof data === 'object') {
    return (
      <>
        <h3>{data.value}</h3>
        <span>{data.description}</span>
      </>
    );
  }
};
